var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"tiBtn",staticClass:"popupbtn",class:_vm.type === 'primary' ? 'primary' : _vm.type === 'secondary' ? 'secondary' : _vm.type === 'ghost' ? 'ghost' : '',attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }